import type { CountryType } from '../types/countries.js';
import type { Env } from '../types/env.js';

export const NM_GATEWAY_PRODUCTION_URL = 'https://nm-gateway.tripleten.com/';

export const DOMAIN_URLS: Record<Env, Record<CountryType, string>> = {
    testing: {
        'es-mex': 'https://testing.tripleten.mx/',
        'es-chl': 'https://testing.tripleten.cl/',
        'es-ecu': 'https://testing.tripleten.ec/',
        'es-per': 'https://testing.tripleten.pe/',
        'pt-bra': 'https://testing.tripleten.com.br/',
        'es-arg': 'https://testing.tripleten.ar/',
        'es-col': 'https://testing.tripleten.co/',
        'en-usa': 'https://testing.tripleten.com/',
    },
    production: {
        'es-mex': 'https://tripleten.mx/',
        'es-chl': 'https://tripleten.cl/',
        'es-ecu': 'https://tripleten.ec/',
        'es-per': 'https://tripleten.pe/',
        'pt-bra': 'https://tripleten.com.br/',
        'es-arg': 'https://tripleten.ar/',
        'es-col': 'https://tripleten.co/',
        'en-usa': 'https://tripleten.com/',
    },
};
